import ApiService from '@/services/api.service.js';
import store from '@/store/index.js';

export default function useProductPriceGroupRepository(pricePeriodId) {
  const appsettings = store.state.appSettings;
  const isNotEmpty = (value) => value !== undefined && value !== null && value !== '';

  const load = (loadOptions) => {
    let params = '?';

    [
      'filter',
      'group',
      'groupSummary',
      'parentIds',
      'requireGroupCount',
      'requireTotalCount',
      'searchExpr',
      'searchOperation',
      'searchValue',
      'select',
      'sort',
      'skip',
      'take',
      'totalSummary',
      'userData',
    ].forEach((i) => {
      if (i in loadOptions && isNotEmpty(loadOptions[i])) {
        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
      }
    });
    params = params.slice(0, -1);

    return ApiService
      .get(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${pricePeriodId}/productpricegroups/overview${params}`);
  };

  const update = (key, values) => ApiService
    .put(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${pricePeriodId}/productpricegroups/${key}`, { values: JSON.stringify(values) });

  const insert = (values) => ApiService
    .post(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${pricePeriodId}/productpricegroups`, { values: JSON.stringify(values) });

  const remove = (key) => ApiService
    .delete(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${pricePeriodId}/productpricegroups/${key}`);

  const loadVolumebasedPrices = (loadOptions, productPriceGroupId) => {
    let params = '?';

    [
      'filter',
      'group',
      'groupSummary',
      'parentIds',
      'requireGroupCount',
      'requireTotalCount',
      'searchExpr',
      'searchOperation',
      'searchValue',
      'select',
      'sort',
      'skip',
      'take',
      'totalSummary',
      'userData',
    ].forEach((i) => {
      if (i in loadOptions && isNotEmpty(loadOptions[i])) {
        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
      }
    });
    params = params.slice(0, -1);

    return ApiService
      .get(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${pricePeriodId}/productpricegroups/${productPriceGroupId}/volumebasedprices/overview${params}`);
  };

  const updateVolumebasedPrice = (key, productPriceGroupId, values) => ApiService
    .put(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${pricePeriodId}/productpricegroups/${productPriceGroupId}/volumebasedprices/${key}`, { values: JSON.stringify(values) });

  const insertVolumebasedPrice = (productPriceGroupId, values) => ApiService
    .post(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${pricePeriodId}/productpricegroups/${productPriceGroupId}/volumebasedprices`, { values: JSON.stringify(values) });

  const removeVolumebasedPrice = (key, productPriceGroupId) => ApiService
    .delete(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${pricePeriodId}/productpricegroups/${productPriceGroupId}/volumebasedprices/${key}`);

  return {
    load,
    update,
    insert,
    remove,
    loadVolumebasedPrices,
    updateVolumebasedPrice,
    insertVolumebasedPrice,
    removeVolumebasedPrice,
  };
}
